import type { ButtonHTMLAttributes } from 'react'

import styles from './Button.module.css'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'link'
  size?: 'default' | 'pill' | 'pill-sm'
}

export function Button({ variant = 'primary', size = 'default', className = '', ...props }: ButtonProps) {
  const sizeClass = size === 'pill-sm' ? styles.pillSm : size === 'pill' ? styles.pill : ''
  return (
    <button
      type="button"
      className={`${styles.button} ${styles[variant]} ${sizeClass} ${className}`}
      {...props}
    />
  )
}
